import React, { useState, useEffect, useRef } from 'react';
import SubmitButton from '../../components/forms/shared/SubmitButton';
import { Card, Col, Form, Input, Row, Spin, Tooltip, Tabs, Avatar, Divider, Button, Switch, Typography, Alert, Checkbox, Select } from 'antd';
import {
  ArrowLeftOutlined,
  CaretDownOutlined,
  EditOutlined,
  EyeOutlined,
  FileTextFilled,
  InfoCircleOutlined,
  LinkOutlined,
  PictureOutlined,
  PlusCircleOutlined,
  QuestionCircleOutlined,
  SettingOutlined,
  StopOutlined,
  UserAddOutlined,
} from '@ant-design/icons';
import QuestionItem from '../../components/forms/QuestionItem';
import AddQuestionButton from '../../components/forms/AddQuestionButton';
import { getTypeIcon, getTypeLabel } from '../../services/util';
import BtnSimpl from '../../components/buttons/BtnSimpl';
import FormTitleInput from '../../components/forms/shared/FormTitleInput';
import DescriptionInput from '../../components/forms/shared/DescriptionInput';
import { useDispatch, useSelector } from 'react-redux';
import { updateFormulaire } from '../../redux/actions/UpdateFormActions';
import { ListFormsActions } from '../../redux/actions/ListFormsActions';
import AvatarConnected from "../../assets/img/imgProfil.png";
import {publishFormulaire} from "../../redux/actions/PublishFormActions";
import ModalComponent from '../../components/modals/ModalComponent';
import { BiWorld } from 'react-icons/bi';
import "./formulaires.css";
import { fermerReponsesFormulaire } from '../../redux/actions/LimitReponseActions';
import TextArea from 'antd/es/input/TextArea';
import Title from 'antd/es/typography/Title';
import { partageFormulaire } from '../../redux/actions/PartageFormActions';
import { getFormById } from '../../redux/actions/GetFormFromIdActions';
import ReponsesViewForm from './ReponsesViewForm';
import Parametres from '../parametres/Parametres';
import "../../components/forms/forms.css";


const { Text } = Typography;

const DetailsForm = ({ onRetour, dataForm }) => {
  const [form] = Form.useForm();
  const [title, setTitle] = useState('Formulaire sans titre');
  const [description, setDescription] = useState('');
  const dispatch = useDispatch();
  const [isFocused, setIsFocused] = useState(false);
const [openModalCopie, setOpenModalCopie] = useState();
const [isClosed, setIsClosed] = useState();
  const [questions, setQuestions] = useState([
    {
      id: null,
      label: '',
      type: 'radio',
      required: false,
      options: [],
      isCollapsed: false,
    },
  ]);
const [emails, setEmails] = useState([]);
const [message, setMessage] = useState("");

useEffect(() => {
    if (dataForm) {
      setTitle(dataForm.title || 'Formulaire sans titre');
      setDescription(dataForm.description || '');
      setQuestions(
        dataForm.fields?.map((field) => ({
          ...field,
          options: field.options || [],
          isCollapsed: true,
        })) || []
      );
    }
  }, [dataForm]);

  const handleAddModelQuestion = () => {
    const updated = questions.map((q) => ({ ...q, isCollapsed: true }));
    const newQuestion = {
      id: Date.now(),
      label: '',
      type: 'radio',
      required: false,
      options: [],
      isCollapsed: false,
    };
    setQuestions([...updated, newQuestion]);
  };

  const handleRetourPrecedent = () => {
    if (onRetour) onRetour();
  };

  const {  form: formById, } = useSelector((state) => state.getFormById);

   useEffect(() => {
    if (dataForm?.id) {
      dispatch(getFormById(dataForm?.id));
    }
  }, [dispatch, dataForm?.id]);

  const {loading:loadingEditForm} = useSelector((state) => state.updateFormulaire);


const handleSubmitEditedForm = async () => {
  const cleanedFields = questions.map(({ isCollapsed, ...rest }) => {
    const isTempId = typeof rest.id === 'number' && rest.id.toString().length > 10;

    return {
      ...rest,
      id: isTempId ? null : rest.id,
    };
  });

  const editedForm = {
    title,
    description,
    fields: cleanedFields,
  };

  await dispatch(updateFormulaire(dataForm.id, editedForm));
  await dispatch(ListFormsActions());
  await dispatch(getFormById(dataForm?.id));
};


const activeCardRef = useRef(null);
const lateralRef = useRef(null);

useEffect(() => {
  if (activeCardRef.current && lateralRef.current) {
    const cardRect = activeCardRef.current.getBoundingClientRect();
    const containerRect = document.querySelector(".stylRowCard")?.getBoundingClientRect();

    const offset = cardRect.top - containerRect.top;
    lateralRef.current.style.transform = `translateY(${offset}px)`;
    lateralRef.current.style.transition = "transform 0.3s ease-in-out";
  }
}, [questions]);


 const itemsTab = [
  { key: '1', label: 'Questions', 
  children: 
        <Row gutter={25} className="stylRowCard" justify="center" align="top">
        <Col span={18}>
          <Form
            form={form}
            onFinish={handleSubmitEditedForm}
          >
            {/* Titre et description */}
            <Card className="cardTitleDescriptionInput">
              <FormTitleInput
                name="title"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                className="titrFormulaire"
                variant="borderless"
              />
              <DescriptionInput
                name="description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </Card>

            {/* Questions */}
            {questions.map((question, index) => (
              <Card
                key={`${question.id}-${index}`}
                ref={!question.isCollapsed ? activeCardRef : null}
                className={question.isCollapsed ? '' : 'stylDefaultCard'}
                style={{ marginTop: '2%', cursor: 'pointer' }}
                onClick={() => {
                  const updated = questions.map((q, i) => ({
                    ...q,
                    isCollapsed: i !== index,
                  }));
                  setQuestions(updated);
                }}
              >
                {question.isCollapsed ? (
                  <>
                    <div
                      style={{
                        padding: '2%',
                        fontSize: '15px',
                        fontWeight: '500',
                        color: '#444',
                      }}
                    >
                      {question.label || 'Question sans titre'}
                    </div>
                    <div style={{ marginTop: '3%' }}>
                      <QuestionItem question={question} isCollapsed={true} />
                    </div>
                  </>
                ) : (
                  <>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gridGap: 20,
                      }}
                    >
                      <Input
                        placeholder="Question"
                        variant="underlined"
                        value={question.label}
                        onChange={(e) => {
                          const updated = [...questions];
                          updated[index].label = e.target.value;
                          setQuestions(updated);
                        }}
                        style={{
                          width: '70%',
                          padding: '2.5%',
                          backgroundColor: '#F1F3F4',
                        }}
                      />
                      <PictureOutlined style={{ fontSize: 22 }} />
                      <BtnSimpl
                        float_="right"
                        buttonText_={getTypeLabel(question.type)}
                        htmlType_="button"
                        borderRadius_="0.5rem"
                        border_={true}
                        width_="100%"
                        height_="8vh"
                        prefix_={getTypeIcon(question.type)}
                        suffix_={
                          <AddQuestionButton
                            onAdd={(type) => {
                              const updated = [...questions];
                              updated[index].type = type;
                              setQuestions(updated);
                            }}
                          />
                        }
                      />
                    </div>

                    <div style={{ marginTop: '3%' }}>
                      <QuestionItem
                        question={question}
                        onChangeOptions={(newOptions) => {
                          const updated = [...questions];
                          updated[index].options = newOptions;
                          setQuestions(updated);
                        }}
                        onDelete={() => {
                          setQuestions((prev) => {
                            const indexToDelete = prev.findIndex(
                              (q) => q.id === question.id
                            );
                            const updated = prev.filter(
                              (q) => q.id !== question.id
                            );
                            if (updated.length === 0) return [];
                            const newIndexToActivate =
                              indexToDelete > 0 ? indexToDelete - 1 : 0;
                            return updated.map((q, i) => ({
                              ...q,
                              isCollapsed: i !== newIndexToActivate,
                            }));
                          });
                        }}
                        onDuplicate={() => {
                          setQuestions((prev) => {
                            const indexToDuplicate = prev.findIndex(
                              (q) => q.id === question.id
                            );
                            const duplicated = {
                              ...question,
                              id: Date.now(),
                              isCollapsed: false,
                            };
                            const updated = prev.map((q) => ({
                              ...q,
                              isCollapsed: true,
                            }));
                            updated.splice(indexToDuplicate + 1, 0, duplicated);
                            return updated;
                          });
                        }}
                        onToggleRequired={(id) =>
                          setQuestions((prev) =>
                            prev.map((q) =>
                              q.id === id
                                ? { ...q, required: !q.required }
                                : q
                            )
                          )
                        }
                      />
                    </div>
                  </>
                )}
              </Card>
            ))}
            <br />
            <Spin className="spinLoading" style={{marginLeft:"43%", marginTop:"3%"}} spinning={loadingEditForm} tip="Enregistrement en cours..." size="large">
            <SubmitButton
              htmlType_="submit"
              className_="stylBtnSubmitForm"
              children="Enregistrer"
              disabled_={loadingEditForm}
            />
             </Spin>
          </Form>
        </Col>

       {/* Barre latérale */}
            <Col span={2} style={{ position: "relative" }}>
              <div className="stylColLateral" ref={lateralRef}>   
                <br/>       
                <Tooltip title="Ajouter une question">
                  <PlusCircleOutlined
                    onClick={handleAddModelQuestion}
                    style={{ fontSize: 22 }}
                  />
                </Tooltip>
                <br />
                {/* <br />
                <Tooltip title="Importer des questions">
                  <DeliveredProcedureOutlined style={{ fontSize: 22 }} />
                </Tooltip>
                <br />
                <br />
                <Tooltip title="Ajouter un titre et une description">
                  <FontSizeOutlined style={{ fontSize: 22 }} />
                </Tooltip>
                <br />
                <br />
                <Tooltip title="Ajouter une image">
                  <PictureOutlined style={{ fontSize: 22 }} />
                </Tooltip> */}
              </div>
            </Col>
      </Row>},
  { key: '2', label: 'Réponses', children: <ReponsesViewForm  donneeFormulaire={dataForm} /> },
  { key: '3', label: 'Paramètres', children: <Parametres donneeFormulaire={dataForm} /> },
];

const [openModalPublished, setOpenModalPublished] = useState();

const handleOpenModalPublished = () => {
  setOpenModalPublished(true);
}

const handleCloseModalPublished = () => {
  setOpenModalPublished(false);
}

const handlePublishForm = async () => {
  const formId = dataForm.id;
    await dispatch(publishFormulaire(formId));
    await dispatch(ListFormsActions());
    await dispatch(getFormById(formId));
   setOpenModalPublished(true);
};

const {loading: loadingPublishForm} = useSelector((state) => state.publishForm )

const [reduir, setReduir] = useState(false);


 useEffect(() => {
    if (formById?.form?.isClosed === false) {
      setIsClosed(true);
    } else {
      setIsClosed(false);
    }
  }, [formById]);
  
const onChangeSwitch = async (checked) => {
  const formId = dataForm?.id;
  const newStatus = checked ? "open" : "close"; 
    await dispatch(fermerReponsesFormulaire(formId, newStatus));
    await dispatch(getFormById(formId));
    await dispatch(ListFormsActions());
};

  const [openModalPartage, setOpenModalPartage] = useState();
 const handleOpenModalPartage = () => {
  setOpenModalPartage(true);
  setReduir(true);
 }
 const handleCloseModalPartage = () => {
  setOpenModalPartage(false);
  setEmails([]);
  setMessage("");
 }
 
const handleOpenModalCopie = () =>  {
  setOpenModalCopie(true);
}
const handleCloseModalCopie = () => {
  setOpenModalCopie(false);
}

const handlePartageFormulaire = async () => {
    const formId = dataForm.id;
const partageData = {
  formId: formId,
  emails: emails,
  message: message
};
   await dispatch(partageFormulaire(partageData));
   await dispatch(ListFormsActions());
   await dispatch(getFormById(formId));
   handleCloseModalPartage();
};

const {loading: loadingPartageForm} = useSelector((state) => state.partageForm)

const isDisabled = (formById?.form?.shareUrl === null || formById?.form?.shareUrl === undefined ); 

const isDesactive = (formById?.form?.isPublished === false);


  return (
    <div>
      <Row>
        <Col span={24} style={{ textAlign: 'right', marginBottom: '3%' }}>
          <BtnSimpl
            onClick_={handleRetourPrecedent}
            boldColor_={600}
            color_="#43CE0C"
            border_="1px solid #43CE0C"
            buttonText_="Retour"
            htmlType_="button"
          />
        </Col>
      </Row>

      <Row gutter={10} >
        <Col span={14} className='stylCol1'>
          <FileTextFilled className='stylIconeFifileText' />
          <FormTitleInput value={title} onChange={(e) => setTitle(e.target.value)} variant="borderless" className="titrFormulaire2" />
        </Col>

          <Col span={10} className='stylCol2'>
                  <a href={`${window.location.origin}/viewFormEnregistre/${btoa(dataForm?.id)}`}
                    target="_blank"  rel="noopener noreferrer" >
                    <Tooltip title="Aperçu">
                      <EyeOutlined style={{ fontSize: 22, color: "#000" }} />
                    </Tooltip>
                  </a>
                    <Tooltip title="Copier le lien pour les répondants">
                        <LinkOutlined
                          style={{
                            fontSize: 22,
                            cursor: isDisabled ? 'not-allowed' : 'pointer',
                            color: isDisabled ? '#C6C6C6' : '#43CE0C'
                          }}
                          onClick={() => {
                            if (!isDisabled) {
                              handleOpenModalCopie();
                            }
                          }}
                        />
                      </Tooltip>
                      <Tooltip title="Partager">
                        <UserAddOutlined
                          style={{
                            fontSize: 22,
                            cursor: isDesactive ? 'not-allowed' : 'pointer',
                            color: isDesactive ? '#C6C6C6' : '#43CE0C'
                          }}
                          onClick={() => {
                            if (!isDesactive) {
                              handleOpenModalPartage();
                            }
                          }}
                        />
                      </Tooltip>
                    {(
                      formById?.form?.isPublished === false) && (
                        <Spin className="spinLoading" spinning={loadingPublishForm} tip="Publication en cours..." size="small">
                      <BtnSimpl disabled_={loadingPublishForm} onClick_={handlePublishForm} padding_="18%" backgroundColor_="#43CE0C" boldColor_={600} color_="#fff" buttonText_="Publier" htmlType_="button" />
                      </Spin>)}
                    { (
                    formById?.form?.isPublished === true)  && (<BtnSimpl onClick_={handleOpenModalPublished}  boldColor_={600} color_="#43CE0C" border_="1px solid #43CE0C" buttonText_="Publié" htmlType_="button" suffix_={<SettingOutlined />} />)}
                    <Avatar style={{marginLeft:"2.5%"}}><img src={AvatarConnected} alt="imag"/></Avatar>
          </Col>
      </Row>

          <Tabs defaultActiveKey="1" centered items={itemsTab} />

        {/* LES MODALS */}
        <div style={{width:"100%"}}>
                            <ModalComponent  
                                _title={<div style={{fontSize:25, fontWeight:"normal", }}>Options de publication</div>}
                                _width="40%"
                                _padding={0}
                                _maskClosable={false}
                                _closable={true} 
                                _open={openModalPublished}
                                _onCancel={handleCloseModalPublished}
                                _form={ 
                                   <div>
                                     <Divider style={{marginTop:12, marginBottom:15}} />
                                            <Row>
                                              <Col span={20}>
                                                {isClosed ? (
                                                  <div style={{ fontSize: 17, fontWeight: 500, marginBottom: "2%" }}>
                                                    <EditOutlined style={{ fontSize: 20, marginRight: "4%" }} />
                                                    Réponses acceptées
                                                  </div>
                                                ) : (
                                                  <div style={{ fontSize: 17, fontWeight: 500, marginBottom: "2%", }}>
                                                    <StopOutlined style={{ fontSize: 20, marginRight: "4%",}} />
                                                    Les réponses ne sont plus acceptées
                                                    <div  style={{ marginTop: "1%", fontSize: 13, marginLeft:"9.4%" }}>
                                                      <span> Les personnes interrogées verront ce message<br /></span>
                                                      <span italic style={{ color: "#555", fontSize: 12  }}>
                                                        "Il n'est plus possible de saisir de réponses dans ce formulaire."
                                                      </span>
                                                    </div>
                                                  </div>
                                                )}
                                              </Col>

                                              <Col span={2}>
                                                <Switch
                                                  checked={isClosed}
                                                  onChange={onChangeSwitch}
                                                  style={{
                                                    backgroundColor: isClosed ? "#43CE0C" : "#d9d9d9"
                                                  }}
                                                />
                                              </Col>
                                            </Row>
                                   
                                    <Divider style={{marginTop:12, marginBottom:15}} />
                                     <div style={{fontSize:17, fontWeight:500, marginBottom:"2%"}}><UserAddOutlined style={{fontSize:20, marginRight:"4%"}} />Répondants</div>
                                      <Row>
                                        <Col span={20}>
                                        <Avatar size="small" style={{backgroundColor:"#E8FCE2", marginLeft:"9%", marginRight:"3%"}}> <BiWorld style={{color:"#43CE0C",  }} /></Avatar>
                                          Tous les utilisateurs qui ont le lien
                                        </Col>
                                        <Col span={4}><Button type="link" onClick={handleOpenModalPartage}>Gérer</Button></Col>
                                      </Row>
                                      <Divider style={{marginTop:12, marginBottom:15}} />
                                         <div > <Button onClick={handleOpenModalCopie} style={{ padding:15.5, color:"#4285F4"}} ><LinkOutlined />Copier le lien pour les répondants</Button></div>
                                   </div>
                                } /> </div> 

           <div style={{width:"100%"}}>
                            <ModalComponent  
                                _title={<> 
                               <div> Copier le lien pour les répondants</div>
                                </>}
                                _zIndex={1100}  
                                _width="30%"
                                _padding={0}
                                _maskClosable={false}
                                _closable={true} 
                                _open={openModalCopie}
                                _onCancel={handleCloseModalCopie}
                                _form={ 
                                  <div style={{marginTop:"2%"}}>
                                      <>
                                      <div> <a rel="noopener noreferrer" href={formById?.form?.shareUrl} target='_blank' >{formById?.form?.shareUrl}</a> </div>
                                    <Divider style={{marginTop:12, marginBottom:15}} />
                                    <div ><Text style={{fontSize:"30px", textAlign:"right"}} className="stylCopyText" copyable={{ text: formById?.form?.shareUrl }}></Text></div><br/></>
                                  </div>
                                }
                            />
          </div> 

          <div style={{width:"100%"}}>
                            <ModalComponent  
                                _title={<Row style={{marginTop:"-1.3%"}}> {isFocused && (<ArrowLeftOutlined onClick={() => {setReduir(true); setIsFocused(false);}} style={{fontSize:18, marginRight:"4%"}} />)}<Col span={18} style={{fontSize:25, fontWeight:"normal", }}>Partager</Col>   
                                <Col span={4} style={{fontSize:18, }}><QuestionCircleOutlined /><SettingOutlined style={{marginLeft:"20%"}} /></Col></Row>}
                                _padding={0}
                                _maskClosable={false}
                                _closable={true} 
                                _open={openModalPartage}
                                _onCancel={handleCloseModalPartage}
                                _form={ 
                                   <div>
                                     <Row gutter={8}>
                                      <Col span={isFocused ? 18 : 24}>
                                        <Select value={emails}
                                          name="emails"
                                          type="email"
                                          mode="tags"
                                          className="stylSelectEmail"
                                          placeholder={
                                            <div style={{ marginTop: "4.5%", color: "#000" }}>
                                              Ajouter des personnes, des groupes et des évenements d'agenda
                                            </div>
                                          }
                                          onChange={(value) => {
                                            setIsFocused(true);
                                            setReduir(false);
                                            setEmails(value)
                                          }}
                                          // options={options}
                                        />
                                      </Col>

                                      {(!reduir && isFocused) && (
                                        <Col span={4}>
                                          <Button style={{ height: "8vh", border: "1px solid" }}>
                                            Répondant <CaretDownOutlined />
                                          </Button>
                                        </Col>
                                      )}
                                    </Row>

                                      { reduir && (
                                        <>
                                      <Title level={4}>Utilisateurs avec accès</Title>
                                      <Row>
                                        <Col span={2} style={{marginTop:7}}><Avatar size="default" style={{backgroundColor:"#E8FCE2"}}> <p style={{color:"#43CE0C", fontSize:20}}> U </p></Avatar></Col>
                                        <Col span={18}>
                                         <strong style={{fontSize:16}}> Mariama Cissé (you) </strong><br/>
                                           mariama@gmail.com
                                        </Col>
                                         <Col span={4}>Proprietaire</Col>
                                      </Row>
                                      </> )}

                                     { (!reduir && isFocused) && ( <>
                                     <br/>
                                      <Checkbox checked={true}
                                      > Envoyer une notification</Checkbox>
                                      <TextArea
                                        value={message}
                                        onChange={e => setMessage(e.target.value)}
                                        autoSize={{ minRows: 8, maxRows: 20 }}
                                      /> <br/></>)}
                                    <br/>
                                        <Alert icon={<InfoCircleOutlined style={{color:"#0C0484", fontSize:20}}/>} showIcon message="Publiez le formulaire pour accepter les réponses" type="info" style={{color:"primary", border:"none", padding:"3%"}}  /><br/>
                                     {reduir && ( <div style={{textAlign:"right", }}><Button onClick={handleCloseModalPartage} type="primary" htmlType='button' style={{backgroundColor:"#43CE0C", borderRadius:"2rem", padding:"4.5%", border:"none"}}>OK</Button></div>)}
                                     { (!reduir && isFocused) && (<div style={{display:"flex", justifyContent:"end", gap:10,  }}>
                                        <Button  htmlType='button' onClick={handleCloseModalPartage} style={{borderRadius:"2rem", padding:"4.5%", border:"none", color:"#43CE0C"}}>Annuler</Button>
                                        <Spin className="spinLoading" spinning={loadingPartageForm} tip="Partage en cours..." size="small">
                                          <Button disabled={loadingPartageForm} onClick={handlePartageFormulaire} type="primary" htmlType='button' style={{backgroundColor:"#43CE0C", borderRadius:"2rem", padding:"4.5%", border:"none"}}>Partager</Button>
                                        </Spin>
                                     </div>)}
                                   </div>
                                } />
          </div>
    </div>
  );
};

export default DetailsForm;
